function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m20.0601 28.5759c1.3968-1.5092 4.9523-3.6222 8 0",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m20.06 28.8368c0 4.757-4.1811 8.7391-9.5 8.7391-5.31887 0-9.5-3.9821-9.5-8.7391 0-.8336-.01946-1.5608-.03611-2.1826-.00179-.067-.00355-.1329-.00525-.1974-.01779-.6754-.02794-1.1926-.00679-1.611.04282-.8471.20004-.9389.301-.9979l.00179-.0011c.1189-.0695.34623-.1528.78696-.2139.43477-.0602 1.00575-.0902 1.768-.0999.78541-.01 1.70612.0011 2.81948.0145 1.08834.0131 2.36079.0284 3.87092.0284 1.5101 0 2.7826-.0153 3.8709-.0284 1.1134-.0134 2.0341-.0245 2.8195-.0145.7622.0097 1.3332.0397 1.768.0999.4407.0611.6681.1444.787.2139l.0017.0011c.101.059.2582.1508.301.9979.0212.4184.011.9356-.0067 1.611-.0017.0645-.0035.1303-.0053.1973-.0166.6218-.0361 1.349-.0361 2.1827z",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m47.1201 28.8368c0 4.757-4.1812 8.7391-9.5 8.7391-5.3189 0-9.5-3.9821-9.5-8.7391 0-.8336-.0195-1.5608-.0361-2.1826-.0018-.067-.0036-.1329-.0053-.1974-.0178-.6754-.0279-1.1926-.0068-1.611.0428-.8471.2001-.9389.301-.9979l.0018-.0011c.1189-.0695.3462-.1528.787-.2139.4347-.0602 1.0057-.0902 1.768-.0999.7854-.01 1.7061.0011 2.8194.0145 1.0884.0131 2.3608.0284 3.871.0284 1.5101 0 2.7825-.0153 3.8709-.0284 1.1133-.0134 2.034-.0245 2.8195-.0145.7622.0097 1.3332.0397 1.768.0999.4407.0611.668.1444.7869.2139l.0018.0011c.101.059.2582.1508.301.9979.0212.4184.011.9356-.0068 1.611-.0017.0645-.0034.1303-.0052.1973-.0167.6218-.0361 1.349-.0361 2.1827z",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m1.06006 23.5759h46.00004",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m1.06006 23 8.5-12.6401c1.00004-1.26398 3.10004-2.78079 3.50004 1.264",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("path", {
  className: "outline outline--stroke",
  d: "m47.0601 23-8.5-12.6401c-1-1.26398-3.1-2.78079-3.5 1.264",
  stroke: "#c5cad1"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m7 30.5858 3.5858-3.5858",
  stroke: "#ffd200"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m9 33.5858 5.5858-5.5858",
  stroke: "#ffd200"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m34 30.5858 3.5858-3.5858",
  stroke: "#ffd200"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight highlight--stroke",
  d: "m36 33.5858 5.5858-5.5858",
  stroke: "#ffd200"
})));

function SvgSunglasses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunglasses);
export default __webpack_public_path__ + "static/media/sunglasses.ecdba5c6.svg";
export { ForwardRef as ReactComponent };